import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const BalanceLabelInnerDefaultBox = styled.div`
    color: ${({theme}) => theme.colors.textMiddleDark};
    font-weight: 600;
`;

const BalanceLabelInnerHarrahsWsopBox = styled(BalanceLabelInnerDefaultBox)`
    ${({theme}) => theme.font.presets.regular}
`;

const BalanceLabelInnerMrGreenBox = styled.div`
    color: ${({theme}) => theme.colors.textActive};
`;

export const BalanceLabelInnerBox = styledByTheme(BalanceLabelInnerDefaultBox)
    .forHarrahs(BalanceLabelInnerHarrahsWsopBox)
    .forWsop(BalanceLabelInnerHarrahsWsopBox)
    .forMrGreen(BalanceLabelInnerMrGreenBox)
    .apply();
